import {
	createContext,
	type FC,
	type ReactNode,
	useContext,
	useState,
} from "react";

interface LogoutLoadingContextType {
	isLoggingOut: boolean;
	setIsLoggingOut: (value: boolean) => void;
}

const LogoutLoadingContext = createContext<
	LogoutLoadingContextType | undefined
>(undefined);

export const useLogoutLoading = () => {
	const context = useContext(LogoutLoadingContext);
	if (!context) {
		throw new Error(
			"useLogoutLoading must be used within LogoutLoadingProvider",
		);
	}
	return context;
};

interface LogoutLoadingProviderProps {
	children: ReactNode;
}

export const LogoutLoadingProvider: FC<LogoutLoadingProviderProps> = ({
	children,
}) => {
	const [isLoggingOut, setIsLoggingOut] = useState(false);

	return (
		<LogoutLoadingContext.Provider value={{ isLoggingOut, setIsLoggingOut }}>
			{children}
		</LogoutLoadingContext.Provider>
	);
};
